import apiClient, { type ApiResponse } from './client'
import type { AdminUser } from '@/store/auth'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  token: string
  expires_at: string
  admin: AdminUser
}

export const authApi = {
  login: async (data: LoginRequest): Promise<ApiResponse<LoginResponse>> => {
    const res = await apiClient.post<ApiResponse<LoginResponse>>('/auth/login', data)
    return res.data
  },

  logout: async (): Promise<ApiResponse<null>> => {
    const res = await apiClient.post<ApiResponse<null>>('/auth/logout')
    return res.data
  },

  me: async (): Promise<ApiResponse<AdminUser>> => {
    const res = await apiClient.get<ApiResponse<AdminUser>>('/auth/me')
    return res.data
  },
}